module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAJRJREFUKFOd0bEOAVEUhOFveQEVlUQUhEQUlDy8SDSiUHoFVKqtkCO7ySW7K0w3yfz3zuRkflSGNhboInypGzaJH+IcgQHGOOKeBHIEFJqhj10AI/SwrWlXhve4fAPewvFgE/AZ7iCvA6bFtleNouqqHF21YVIEr8mudRNQtf9/oO4O6S8tzHGK0WGWFZdOgUf0x+EJRIUk72E5nZoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/edit.png
// module id = XuxF
// module chunks = 1